import { gql } from "@apollo/client"
export const GET_COMPANY_STATS = gql`
query getCompanyStats($id:UUID!){
  company(id:$id){
    id
    name
    paidUsers
    activeUsers
    companySubscriptions{
      startDate
      endDate
    }
    sessions{
      id
      type
      category
      data
      status
      checkpoint {
        current {
          name
        }
      }
    }
  }
}
`